import { render, staticRenderFns } from "./AppGlobalSidebar.vue?vue&type=template&id=59537e3e&"
import script from "./AppGlobalSidebar.vue?vue&type=script&lang=js&"
export * from "./AppGlobalSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports